import {Box, Grid, Stack, Text} from '@primer/react-brand/esm'

import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'
import {isLink} from '@github-ui/swp-core/schemas/contentful/contentTypes/link'
import type {PrimerComponentSectionIntro} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSectionIntro'

import {useGenericCtaAction} from '../../../../brand/components/GenericCtaAction/use-generic-cta-action'
import {resolveGenericContentCta, type GenericContent} from '../../../../brand/lib/types/contentful'

import IdeList from '../_components/IdeList/IdeList'

type Props = {
  content: {
    sectionIntro?: PrimerComponentSectionIntro
    cta?: GenericContent
  }
}

export function CtaSection({content}: Props) {
  const {sectionIntro, cta: featuresCopilotPlansCta} = content
  const ctaLink = featuresCopilotPlansCta
    ? resolveGenericContentCta(featuresCopilotPlansCta, {legacyLinksAsCta: true})?.primary
    : undefined
  const ctaAction = useGenericCtaAction(ctaLink, {
    analytics: {tag: 'button', context: 'ide_list', location: 'cta'},
    variant: (isLink(ctaLink) && ctaLink.fields.variant) || 'subtle',
    className: 'lp-Features-secondaryButton',
  })

  return (
    /* eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals */
    <Grid as="section" className="lp-Section tmp-pt-5 tmp-pt-lg-8 tmp-pb-8">
      <Grid.Column span={{xsmall: 12, small: 8}} start={{xsmall: 1, small: 3}}>
        <Stack direction="vertical" gap={40} className="text-center p-0">
          {sectionIntro ? (
            <ContentfulSectionIntro component={sectionIntro} fullWidth headingSize="3" className="p-0" />
          ) : null}

          <IdeList type="big" location="pricing-cta" />

          {featuresCopilotPlansCta ? (
            <Box>
              <Text size="300" weight="normal" variant="muted">
                {featuresCopilotPlansCta.fields.heading}
              </Text>

              {ctaAction.action ? (
                <Box marginBlockStart={24}>
                  {ctaAction.action}
                  {ctaAction.feedback}
                </Box>
              ) : null}
            </Box>
          ) : null}
        </Stack>
      </Grid.Column>
    </Grid>
  )
}
